'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _radium = require('radium');

var _radium2 = _interopRequireDefault(_radium);

var _categoryIcon = require('../categoryIcon');

var _categoryIcon2 = _interopRequireDefault(_categoryIcon);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (_typeof(call) === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + _typeof(superClass));
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var styles = {
  button: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    cursor: 'pointer',
    margin: '0 auto',
    transition: '.25s ease-in-out'
  },
  text: {
    overflowWrap: 'break-word',
    maxWidth: 'calc(100% - 50px)',
    textAlign: 'left',
    hyphens: 'auto'
  }
};

var CategoryIconButton = function (_React$Component) {
  _inherits(CategoryIconButton, _React$Component);

  function CategoryIconButton(props) {
    _classCallCheck(this, CategoryIconButton);

    var _this = _possibleConstructorReturn(this, (CategoryIconButton.__proto__ || Object.getPrototypeOf(CategoryIconButton)).call(this, props));

    _this.state = {
      selected: false,
      hovered: false
    };
    _this.handleClick = _this.handleClick.bind(_this);
    _this.handleHover = _this.handleHover.bind(_this);
    _this.handleUnhover = _this.handleUnhover.bind(_this);
    return _this;
  }

  _createClass(CategoryIconButton, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (this.props.selected !== prevProps.selected) {
        this.setState({
          selected: this.props.selected
        });
      }
    }
  }, {
    key: 'dimension',
    value: function dimension() {
      return {
        width: this.props.width || 'auto',
        height: this.props.height || 'auto'
      };
    }
  }, {
    key: 'colors',
    value: function colors() {
      return {
        backgroundColor: this.props.backgroundColor || 'initial',
        color: this.props.color || 'initial',
        border: '2px solid ' + this.props.borderColor || '2px solid initial',
        ':hover': window.matchMedia("(max-width: 768px)").matches ? {} : {
          backgroundColor: this.props.hoverBackgroundColor || this.props.backgroundColor,
          color: this.props.hoverColor || this.props.color,
          borderColor: this.props.hoverBorderColor || this.props.borderColor
        }
      };
    }
  }, {
    key: 'font',
    value: function font() {
      return {
        fontFamily: this.props.fontFamily || '"Gotham SSm A", "Gotham SSm B"',
        fontSize: this.props.fontSize || '16px',
        fontWeight: this.props.fontWeight || 400,
        textTransform: this.props.textTransform || 'uppercase'
      };
    }
  }, {
    key: 'handleClick',
    value: function handleClick(e) {
      var _this2 = this;

      e.preventDefault();
      this.setState({
        selected: this.state.selected ? false : true
      }, function () {
        if (_this2.props.handleSelect) {
          _this2.props.handleSelect(_this2.state.selected, _this2.props.text);
        }
      });

      if (this.props.onClick) {
        this.props.onClick();
      }
    }
  }, {
    key: 'selected',
    value: function selected() {
      return {
        backgroundColor: this.props.activeBackgroundColor || this.props.backgroundColor,
        color: this.props.activeColor || this.props.color,
        borderColor: this.props.activeBorderColor || this.props.borderColor,
        ':hover': {
          backgroundColor: this.props.activeBackgroundColor || this.props.hoverBackgroundColor,
          color: this.props.activeColor || this.props.hoverColor,
          borderColor: this.props.activeBorderColor || this.props.hoverBorderColor
        }
      };
    }
  }, {
    key: 'unselected',
    value: function unselected() {
      return {
        backgroundColor: this.props.backgroundColor,
        color: this.props.color,
        borderColor: this.props.borderColor
      };
    }
  }, {
    key: 'handleHover',
    value: function handleHover() {
      this.setState({
        hovered: true
      });
    }
  }, {
    key: 'handleUnhover',
    value: function handleUnhover() {
      this.setState({
        hovered: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var Element = this.props.href ? "a" : "div";
      var role = Element === "a" ? "button" : null;
      var selected = this.state.selected ? this.selected() : this.unselected();
      var style = [this.dimension(), this.colors(), this.font(), selected, styles.button, this.props.customStyles];
      var iconStatus = 'default';

      if (this.state.selected) {
        iconStatus = 'selected';
      } else if (!window.matchMedia("(max-width: 768px)").matches && this.state.hovered) {
        iconStatus = 'hover';
      }

      return _react2["default"].createElement(Element, {
        className: 'CategoryIconButton',
        style: style,
        href: this.props.href,
        role: role,
        disabled: this.props.disabled,
        onClick: this.handleClick,
        onMouseEnter: this.handleHover,
        onMouseLeave: this.handleUnhover,
        tabIndex: '0'
      }, _react2["default"].createElement(_categoryIcon2["default"].component, {
        category: this.props.category,
        status: iconStatus
      }), _react2["default"].createElement('div', {
        style: styles.text
      }, this.props.text));
    }
  }]);

  return CategoryIconButton;
}(_react2["default"].Component);

var component = (0, _radium2["default"])(CategoryIconButton);
exports["default"] = {
  component: component
};